import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SeoMeta, SiteFooter } from "../shared/site";
import '../index.css';

export default function App() {
  const [particles, setParticles] = useState([]);
  useEffect(() => {
    const generated = Array.from({ length: 40 }, () => ({
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 4 + 2,
      duration: Math.random() * 20 + 10,
    }));
    setParticles(generated);
  }, []);

  const sections = [
    { id: "Payement", title: "Payment and delivery options" },
    { id: "Refund", title: "Refund Policy" },
  ];

  return (
    <div className="relative min-h-screen flex flex-col bg-transparent text-white font-jersey overflow-hidden">
      <SeoMeta
        title="Delivery and Payment"
        description="HackSeller delivery, payment options and refund policy for private gaming tools."
        canonicalPath="/Delivery"
      />
      {/* Particules animées */}
      <div className="absolute inset-0 overflow-hidden">
        {particles.map((p, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-purple-500/20 shadow-lg"
            style={{ top: `${p.y}%`, left: `${p.x}%`, width: p.size, height: p.size }}
            animate={{ y: ["0%", "-200%"], opacity: [0.2, 0] }}
            transition={{ duration: p.duration, repeat: Infinity, ease: "linear" }}
          />
        ))}
      </div>

      <div className="relative z-10">
        {/* Navbar */}
        <motion.nav
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="bg-gray-950/55 backdrop-blur-xl shadow-[0_12px_45px_rgba(124,58,237,0.22)] p-4 px-8 flex justify-between items-center fixed top-0 w-full z-50 rounded-b-xl border border-purple-400/20"
        >
          <h1 className="text-4xl font-extrabold text-purple-500 tracking-tight drop-shadow-glow cursor-pointer">
            <Link to="/" className="hover:text-purple-400 transition-colors">
              Hack<span className="text-white">seller</span>
            </Link>
          </h1>

          <ul className="hidden md:flex space-x-8 lg:space-x-10 text-gray-200 font-bold text-xl lg:text-2xl">
            <li>
              <a href="https://discord.gg/HdZBtMFsWA" target="_blank" rel="noopener noreferrer" className="hover:text-purple-400 cursor-pointer transition-colors">
                Help
              </a>
            </li>
            <li>
              <Link to="/Status" className="hover:text-purple-400 transition-colors">
                Status
              </Link>
            </li>
            <li>
              <Link to="/Spoofer" className="hover:text-purple-400 transition-colors">
                Spoofer
              </Link>
            </li>
            <li>
              <Link to="/faq" className="hover:text-purple-400 transition-colors">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/Dma" className="hover:text-purple-400 transition-colors">
                DMA
              </Link>
            </li>
          </ul>
        </motion.nav>

        {/* Section Terms of Use */}
        <section className="pt-28 px-8 md:px-16 py-20 bg-purple-950/25 backdrop-blur-[2px] border-b border-purple-400/20 rounded-b-3xl shadow-[0_18px_60px_rgba(124,58,237,0.18)]">
          <h2 className="text-4xl md:text-5xl font-extrabold text-center text-white mb-10">Delivery and Payment, Returns</h2>

          {/* Table of Contents */}
          <div className="bg-gray-950/55 border border-purple-400/20 p-6 rounded-xl shadow-[0_16px_45px_rgba(124,58,237,0.16)] mb-10 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-purple-400 mb-4 text-center">Sections</h3>
            <ul className="space-y-3 text-lg text-gray-300 text-center">
              {sections.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`} className="hover:text-purple-400 transition-colors">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-gray-300 text-lg md:text-xl leading-relaxed space-y-10 max-w-5xl mx-auto whitespace-pre-line">

            <div id="Payement">
              <h3 className="text-2xl font-bold text-purple-400 mb-4">Payment and delivery options</h3>
              <p>You can pay for the goods by one of the payment methods offered on the site. Payment passes through various payment services. Available at the moment payment methods: Bank cards, FREEKASSA, Yumoney and some others.</p><br />

              <p>The paid goods user receives in manual or automatic mode on the same page on which the payment was made. Also in the process of payment the user indicates e-mail, to which is sent a link to access the paid goods.</p><br />

              <p>Issuance of goods is most often instant, but in some cases, can take from 10 minutes to 24 hours.</p>
            </div>

            <div id="Refund">
              <h3 className="text-2xl font-bold text-purple-400 mb-4">Refund Policy</h3>
              <p> Refund for purchased goods is provided for cases when the Administration of the site is unable to fulfill its obligations. Such cases include incorrectly issued activation key, impossibility to provide the product and other deviations in the normal functioning of the goods paid for by the buyer.Refund for purchased goods is provided for cases when the Administration of the site is unable to fulfill its obligations. Such cases include incorrectly issued activation key, inability to provide the product and other deviations in the normal functioning of the goods paid for by the buyer.</p><br />

              <p>Refund or key replacement is NOT CARRIED OUT if :</p>
              <p>- The product is on update (before purchase, after purchase)</p>
              <p>- If you refuse to follow the instructions to the product or manuals of the support staff</p>
              <p>- If you don't understand how to set up your PC, if you're having trouble setting it up</p>
              <p>- If for some reason you don't need the product</p>
              <p>- If you're too lazy to understand the instructions or settings</p>
              <p>- You bought the wrong product</p>
              <p>- You were banned or blocked in the game</p>
              <p>- You haven't studied the technical requirements for the PC (windows version, processor, etc.)</p>
              <p>- Functionality partially does not coincide with the description on the site (often this or that feature may be disabled for testing, or disabled for good, so the information on the site is not always final and accurate).</p>
              <p>- The product is temporarily inoperable</p>
              <p>- You did not make sure that the status of the product: Available</p>
              <p>- If you use the key on several computers and you have an infinite error: Invalid HWID (1 key can be used only on 1 PC)</p><br />

              <p>Refunds are made to the details that the buyer used to pay for the product. To request a refund, please contact the Administration of the site. For all questions related to the purchase, write to the contacts listed on the site.</p>
            </div>
          </div>
        </section>

        <SiteFooter />
      </div>
    </div>
  );
}
